import React from "react";

/**
 * @component PeopleIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <PeopleIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const PeopleIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="PeopleIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path d="M20.998 16.775l-.148-.387a2.001 2.001 0 00-1.601-1.27 12.961 12.961 0 00-2.317-.105c-.253-.76-.683-1.527-.932-1.937a14.912 14.912 0 013.518.06 4.003 4.003 0 013.203 2.54l.147.387a2 2 0 01-1.614 2.696 27.849 27.849 0 01-3.248.24c0-.355-.004-.741-.127-1.115L17.587 17a27.311 27.311 0 003.41-.225zM17.5 10a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm0 2a3.5 3.5 0 110-7 3.5 3.5 0 010 7zM5.437 14.315a2 2 0 00-1.494 1.333L3 18.51c1.826.327 3.65.49 5.473.49a30.99 30.99 0 005.474-.49l-.943-2.862a2 2 0 00-1.494-1.333A14.924 14.924 0 008.473 14c-1.01 0-2.021.105-3.036.315zm-.406-1.958A16.924 16.924 0 018.473 12c1.148 0 2.295.119 3.443.357a4 4 0 012.987 2.665l.943 2.862A2 2 0 0114.3 20.48a33.015 33.015 0 01-5.827.52c-1.941 0-3.883-.174-5.825-.521a2 2 0 01-1.547-2.595l.942-2.862a4 4 0 012.988-2.665zM8.474 9a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm0 2a4.5 4.5 0 110-9 4.5 4.5 0 010 9z" />
      <path
        stroke="#F4F5F7"
        strokeWidth={0.1}
        opacity={0.01}
        d="M.05.05h23.9v23.9H.05z"
      />
    </svg>
  )
);
PeopleIcon.displayName = "PeopleIcon";
export default PeopleIcon;
